import React from 'react';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { faReply } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';

import { Box, Button, Text } from 'components';
import { useWindowSize } from 'hooks';
import { theme } from 'utils';

const Icon = styled(FontAwesomeIcon)`
	color: ${theme.colors.danger};

	@media (min-width: 1023px) {
		font-size: 120px;
	}
`;

export const ErrorScreen = () => {
	let history = useHistory();
	let { innerWidth } = useWindowSize();

	const volver = () => {
		history.push('/panel/alumnos');
	}

	return (
		<Box
			display="flex"
			justifyContent="space-around"
			alignItems="center"
			height="calc(100vh - 146px)"
		>
			{innerWidth > 1023 && (
				<Icon icon={faTimesCircle} />
			)}
			<Box display="flex" flexDirection="column" justifyContent="center"  alignItems={innerWidth < 1023 ? "center" : "flex-start"}>
				<Text mb={10} as ="h1" textAlign="center">
					{innerWidth < 1023 && (
						<Icon icon={faTimesCircle} />
					)} Algo ha salido mal
				</Text>
				<Text mb={20}>Por favor, contacte con el centro.</Text>
				<Button onClick={volver} icon={faReply}>
					Volver
				</Button>
			</Box>
		</Box>
	)
}